import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { persistedReducer } from './rootReducers'

const store = configureStore({
    reducer:persistedReducer,
    middleware: getDefaultMiddleware({
        serializableCheck: false,
        check: function(){
            console.log("Hello world")
        }
    }),
    devTools: true,
})

export default store


// https://edvins.io/how-to-use-redux-persist-with-redux-toolkit